import { CartaoPeriodoPadrao } from '../shared/enums/cartao-periodo-padrao.enum';

export class CartaoCadastro {
    public cartaoId: number;
    public produtoGuid: string;
    public descricaoProduto: string;
    public ativo: boolean;
    public cedenteContratoId: number;
    public categoriaProduto: number;
    public ehEditavel: boolean;
    public vencido: boolean;
    public suspenso: boolean;
    constructor(
        public valorPadrao: number,
        public cartaoPeriodoPadrao: CartaoPeriodoPadrao
    ) { }
}
